"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormCheckbox = void 0;
const react_1 = __importDefault(require("react"));
const FormField_1 = require("../base/FormField");
const FieldWrapper_1 = require("./FieldWrapper");
class FormCheckbox extends FormField_1.FormField {
    render() {
        return (react_1.default.createElement(FieldWrapper_1.FormFieldWrapper, Object.assign({}, this.wrapperProps),
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: `form__checkbox-square ${this.value ? "is-checked" : ""}` }, this.value ? "check" : ""),
                react_1.default.createElement("input", { type: "checkbox", checked: this.value, onChange: (e) => this.setValue(e.target.checked), className: "form__checkbox-input" }),
                react_1.default.createElement("div", { className: "form__checkbox-label", onClick: () => this.setValue(!this.value) }, this.props.checkboxLabel))));
    }
}
exports.FormCheckbox = FormCheckbox;
//# sourceMappingURL=Checkbox.js.map